import Actions from './actions';
import GifController from '../controllers/GifController';
import { uploadImage } from './uploadActions';
import commonHandler from '../errorHandlers/common-handler';
import { Dispatch } from 'redux';
import { StoreState } from '../store-interfaces';
import { useDispatch } from 'react-redux';

const getPredictions =
  (searchPhrase: string) => async (dispatch: Dispatch<StoreState>) => {
    dispatch({ type: Actions.START_GET_GIF_PREDICTIONS });
    try {
      const response = await GifController.getPredictions(searchPhrase);
      dispatch({ type: Actions.FINISH_GET_GIF_PREDICTIONS });

      if (response && response.data) {
        return response.data;
      }
    } catch (e) {
      commonHandler(dispatch)(e);
    }
  };

const getGifFromUrl =
  (url: string) => async (dispatch: Dispatch<StoreState>) => {
    dispatch({ type: Actions.START_DOWNLOADING_GIF });
    try {
      const response = await GifController.downloadGif(url);
      response.name = `gif_${Math.random()
        .toString(16)
        .slice(-4)}-${Math.random().toString(16).slice(-4)}`;
      const id = await dispatch(
        uploadImage({
          content: response,
          extension: 'gif',
        }),
      );
      dispatch({ type: Actions.END_DOWNLOADING_GIF });
      return id;
    } catch (e) {
      commonHandler(dispatch)(e);
    }
  };

export const useGifActions = () => {
  const dispatch: Dispatch<StoreState> = useDispatch();

  return {
    getPredictions: (searchPhrase: string) =>
      dispatch(getPredictions(searchPhrase)),
    getGifFromUrl: (url: string) => dispatch(getGifFromUrl(url)),
  };
};
